// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bitmask {
    border-collapse: collapse;
    user-select: none;
}
.bitmask.vertical {
    margin: 10px 0 10px 10px;
}

.bitmask td {
    border: 1px solid #888;
    padding: 0;
    height: 10px;
    width: 18px;
    text-align: center;
}
.bitmask.vertical td {
    font-size: 13px;
    height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/widgets/bitmask.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".bitmask {\n    border-collapse: collapse;\n    user-select: none;\n}\n.bitmask.vertical {\n    margin: 10px 0 10px 10px;\n}\n\n.bitmask td {\n    border: 1px solid #888;\n    padding: 0;\n    height: 10px;\n    width: 18px;\n    text-align: center;\n}\n.bitmask.vertical td {\n    font-size: 13px;\n    height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
